const STORAGE_KEYS = {
  accounts: "eis_accounts",
  session: "eis_user",
  school: "eis_school_state",
};

export const EXAMS = [
  { key: "pt1", label: "Periodic Test 1" },
  { key: "pt2", label: "Periodic Test 2" },
  { key: "half-yearly", label: "Half Yearly" },
  { key: "annual", label: "Annual" },
];

export const STANDARDS = [
  "Dummy",
  "Nursery",
  "Jr. KG",
  "Sr. KG",
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
  "11th",
  "12th",
];

export const CLASS_DIVISIONS = {
  Dummy: [{ value: "A", label: "A" }],
  Nursery: [{ value: "Eva", label: "Eva" }],
  "Jr. KG": [{ value: "Eliza", label: "Eliza" }],
  "Sr. KG": [{ value: "Iris", label: "Iris" }],
  "1st": [
    { value: "A. Brihaspati", label: "A. Brihaspati" },
    { value: "B. Sushruta", label: "B. Sushruta" },
    { value: "C. Kapila", label: "C. Kapila" },
    { value: "D. Shukra", label: "D. Shukra" },
  ],
  "2nd": [
    { value: "A. Gautama", label: "A. Gautama" },
    { value: "B. Bhrigu", label: "B. Bhrigu" },
    { value: "C. Kanad", label: "C. Kanad" },
    { value: "D. Parashar", label: "D. Parashar" },
  ],
  "3rd": [
    { value: "A. Agastya", label: "A. Agastya" },
    { value: "B. Pulasya", label: "B. Pulasya" },
    { value: "C. Panini", label: "C. Panini" },
    { value: "D. Nagarjuna", label: "D. Nagarjuna" },
  ],
  "4th": [
    { value: "A. Kashyap", label: "A. Kashyap" },
    { value: "B. Vashishtha", label: "B. Vashishtha" },
    { value: "C. Durvasa", label: "C. Durvasa" },
    { value: "D. Markandeya", label: "D. Markandeya" },
  ],
  "5th": [
    { value: "A. Valmiki", label: "A. Valmiki" },
    { value: "B. Vyas", label: "B. Vyas" },
    { value: "C. Maharshi Garg", label: "C. Maharshi Garg" },
    { value: "D. Kanva", label: "D. Kanva" },
  ],
  "6th": [
    { value: "A. Bhardwaj", label: "A. Bhardwaj" },
    { value: "B. Vamdev", label: "B. Vamdev" },
  ],
  "7th": [
    { value: "A. Atri", label: "A. Atri" },
    { value: "B. Maharshi Shaunaka", label: "B. Maharshi Shaunaka" },
  ],
  "8th": [{ value: "A. Bhaskaracharya", label: "A. Bhaskaracharya" }],
  "9th": [{ value: "A. Aryabhatta", label: "A. Aryabhatta" }],
  "10th": [{ value: "A. Chanakya", label: "A. Chanakya" }],
};

export const SCHOOL_CLASS_STANDARDS = [
  "Dummy",
  "Nursery",
  "Jr. KG",
  "Sr. KG",
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
];

export function getDivisionsForStandard(standard) {
  return CLASS_DIVISIONS[standard] || [];
}

export const NOTIFICATION_TYPES = {
  attendance: "attendance",
  upload: "upload",
  fees: "fees",
  edit_request: "edit_request",
  account_delete_request: "account_delete_request",
  remark: "remark",
  circular: "circular",
  admin_update: "admin_update",
  leave_request: "leave_request",
  leave_status: "leave_status",
};

const DEFAULT_CLASSES = SCHOOL_CLASS_STANDARDS.flatMap((standard) =>
  getDivisionsForStandard(standard).map((division) => ({
    key: classKey(standard, division.value),
    standard,
    division: division.value,
    label: `${standard} ${division.label}`,
  })),
);

const DEFAULT_STUDENTS = [];

const TEST_PAYMENT_STUDENT = {
  name: "test8",
  email: "test8@eureka.school",
  studentName: "test8",
};

const SEEDED_STUDENT = {
  id: "student-dummy-one",
  name: TEST_PAYMENT_STUDENT.name,
  studentName: TEST_PAYMENT_STUDENT.studentName,
  motherName: "Dummy Mother",
  fatherName: "Dummy Father",
  phone: "9999999999",
  rollNo: 1,
  standard: "Dummy",
  division: "A",
  transportMode: "Bus",
  address: "Eureka International School",
  email: TEST_PAYMENT_STUDENT.email,
  accountStatus: "active",
};

const SEEDED_STUDENT_ACCOUNT = {
  id: SEEDED_STUDENT.id,
  studentId: SEEDED_STUDENT.id,
  role: "student",
  name: SEEDED_STUDENT.name,
  email: SEEDED_STUDENT.email,
  password: "Student@123",
  studentName: SEEDED_STUDENT.studentName,
  motherName: SEEDED_STUDENT.motherName,
  fatherName: SEEDED_STUDENT.fatherName,
  phone: SEEDED_STUDENT.phone,
  rollNo: SEEDED_STUDENT.rollNo,
  standard: SEEDED_STUDENT.standard,
  division: SEEDED_STUDENT.division,
  transportMode: SEEDED_STUDENT.transportMode,
  address: SEEDED_STUDENT.address,
  classKey: classKey(SEEDED_STUDENT.standard, SEEDED_STUDENT.division),
};

const SEEDED_TEACHER_ACCOUNT = {
  id: "teacher-ananya-sharma",
  role: "teacher",
  name: "Ananya Sharma",
  email: "ananya.sharma@eureka.school",
  password: "Teacher@123",
  assignedClassKey: classKey("Dummy", "A"),
};

const SEEDED_ADMIN_ACCOUNT = {
  id: "admin-admin-user",
  role: "admin",
  name: "Admin User",
  email: "admin@eureka.school",
  password: "Admin@123",
};

const SEEDED_MANAGEMENT_ACCOUNT = {
  id: "management-management-user",
  role: "management",
  name: "Management User",
  email: "management@eureka.school",
  password: "Management@123",
};

const DEFAULT_HOME_PAGE = {
  aboutUs: `
WELCOME TO EUREKA INTERNATIONAL SCHOOL
Eureka International School offers a well-rounded educational experience focusing on the holistic development of every student by inculcating a wide array of sports, performing arts, extra-curricular activities, and special events along with the academic curriculum. Our objective is to impart knowledge by inducing an enthusiasm to learn among the students, and encouraging them to apply their creativity to go beyond the boundaries of conventional learning. We emphasis on the individual qualities of every student, and work towards combining their personal abilities with the learning methodology at the schools.

OUR VISION
To be the premier educational institution that provides its learners with an environment that inculcates a growth mind set, instil universal values and to equip them with high Emotional Intelligence and technological skills to face the 21st Century. Eureka International School would like to, build a community of mindful, impactful and empathetic world leaders.

OUR Mission
‘MOULDING THE FUTURE’ The motto of our school is ‘Moulding the Future’, which we have expressed in the pregnant Sanskrit form, भविष्यस्य संस्कार: (Bhavisyasya Samskarah). Children/Students are our future.`,
  events: [
    { id: "event-1", src: "/img/events/1.jpg" },
    { id: "event-2", src: "/img/events/2.jpg" },
    { id: "event-3", src: "/img/events/3.jpg" },
    { id: "event-4", src: "/img/events/4.jpg" },
    { id: "event-5", src: "/img/events/5.jpg" },
  ],
  achievements: [
    { id: "ach-1", src: "/img/events/2.jpg" },
    { id: "ach-2", src: "/img/events/4.jpg" },
  ],
};

function safeParse(value, fallback) {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function readJSON(key, fallback) {
  return safeParse(localStorage.getItem(key), fallback);
}

function writeJSON(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function sanitizeSessionUser(user) {
  if (!user) return user;
  const { password, ...safeUser } = user;
  return safeUser;
}

function uniqBy(items, getKey) {
  const map = new Map();
  items.forEach((item) => {
    map.set(getKey(item), item);
  });
  return Array.from(map.values());
}

function stripResultPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return payload;
  }
  const { dataUrl, ...rest } = payload;
  return rest;
}

function sanitizeResults(results = {}) {
  return Object.fromEntries(
    Object.entries(results || {}).map(([classKeyValue, students]) => [
      classKeyValue,
      Object.fromEntries(
        Object.entries(students || {}).map(([studentId, exams]) => [
          studentId,
          Object.fromEntries(
            Object.entries(exams || {}).map(([examKey, payload]) => [
              examKey,
              stripResultPayload(payload),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function stripTimetablePayload(payload) {
  if (!payload || typeof payload !== "object") {
    return payload;
  }
  const { dataUrl, ...rest } = payload;
  return rest;
}

function stripSingleFilePayload(payload) {
  if (!payload || typeof payload !== "object") {
    return payload;
  }
  const { dataUrl, ...rest } = payload;
  return rest;
}

function normalizeText(value) {
  return (value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

function normalizeStudentName(student) {
  return normalizeText(student?.studentName || student?.name);
}

function isPendingStudent(student) {
  return (student?.accountStatus || "active") === "pending" || !student?.email;
}

function userKey(user) {
  if (!user) return "";
  return `${user.role || "user"}:${user.email || user.id || user.name || ""}`;
}

function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function formatDateKey(date) {
  return date.toISOString().slice(0, 10);
}

const FEE_INSTALLMENT_COUNT = 3;

function createEmptyFeeInstallment(index) {
  return {
    label: `Installment ${index + 1}`,
    amount: 0,
    dueDate: "",
  };
}

function normalizeFeeInstallment(installment, index) {
  const fallback = createEmptyFeeInstallment(index);
  return {
    label: installment?.label?.trim() || fallback.label,
    amount: Number(installment?.amount || 0),
    dueDate: installment?.dueDate || "",
  };
}

function splitAmountAcrossInstallments(totalAmount) {
  const total = Number(totalAmount) || 0;
  const base = Math.floor(total / FEE_INSTALLMENT_COUNT);
  const remainder = total - base * FEE_INSTALLMENT_COUNT;
  return Array.from({ length: FEE_INSTALLMENT_COUNT }, (_, index) => ({
    ...createEmptyFeeInstallment(index),
    amount: base + (index === FEE_INSTALLMENT_COUNT - 1 ? remainder : 0),
  }));
}

function normalizeFeePlan(plan = {}, fallbackAmount = 0, fallbackDueDate = "") {
  const legacyAmount = Number(plan.amount || 0);
  const totalAmount = Number(plan.totalAmount || legacyAmount || fallbackAmount || 0);
  const legacyInstallments = Array.isArray(plan.installments) ? plan.installments : [];
  const installments = legacyInstallments.length
    ? Array.from({ length: FEE_INSTALLMENT_COUNT }, (_, index) =>
        normalizeFeeInstallment(legacyInstallments[index], index),
      )
    : splitAmountAcrossInstallments(totalAmount);

  if (fallbackDueDate && !installments[0].dueDate) {
    installments[0] = {
      ...installments[0],
      dueDate: fallbackDueDate,
    };
  }

  const normalizedTotal = totalAmount || installments.reduce((sum, installment) => sum + Number(installment.amount || 0), 0);

  return {
    totalAmount: normalizedTotal,
    installments,
    amount: normalizedTotal,
    dueDate: installments.find((item) => item.dueDate)?.dueDate || fallbackDueDate || "",
  };
}

const DEFAULT_FEE_PLANS = [
  {
    standards: ["Nursery", "Jr. KG", "Sr. KG"],
    totalAmount: 35000,
    installments: [
      { label: "Installment 1", amount: 16000, dueDate: "Beginning of term" },
      { label: "Installment 2", amount: 10000, dueDate: "30 June" },
      { label: "Installment 3", amount: 9000, dueDate: "30 Sep" },
    ],
  },
  {
    standards: ["1st", "2nd", "3rd", "4th"],
    totalAmount: 42500,
    installments: [
      { label: "Installment 1", amount: 21250, dueDate: "Beginning of term" },
      { label: "Installment 2", amount: 12750, dueDate: "30 June" },
      { label: "Installment 3", amount: 8500, dueDate: "30 Sep" },
    ],
  },
  {
    standards: ["5th", "6th", "7th", "8th"],
    totalAmount: 45000,
    installments: [
      { label: "Installment 1", amount: 22500, dueDate: "Beginning of term" },
      { label: "Installment 2", amount: 13500, dueDate: "30 June" },
      { label: "Installment 3", amount: 9000, dueDate: "30 Sep" },
    ],
  },
  {
    standards: ["9th", "10th"],
    totalAmount: 50000,
    installments: [
      { label: "Installment 1", amount: 25000, dueDate: "Beginning of term" },
      { label: "Installment 2", amount: 25000, dueDate: "30 June" },
    ],
  },
];

export function getDefaultFeePlanGroups() {
  return DEFAULT_FEE_PLANS.map((group) => ({
    title:
      group.standards.length === 3
        ? "Pre-Primary"
        : group.standards[0] === "1st"
          ? "Primary"
          : group.standards[0] === "5th"
            ? "Middle School"
            : "Secondary",
    standards: group.standards,
    totalAmount: group.totalAmount,
    installments: group.installments,
  }));
}

function getDefaultFeePlanForStandard(standard) {
  const group = DEFAULT_FEE_PLANS.find((item) => item.standards.includes(standard));
  if (!group) {
    return normalizeFeePlan();
  }
  return normalizeFeePlan(
    {
      totalAmount: group.totalAmount,
      installments: group.installments,
    },
    group.totalAmount,
    group.installments[0]?.dueDate || "",
  );
}

export function classKey(standard, division) {
  return `${standard}__${division}`.replace(/\s+/g, "-");
}

function normalizeClassDivision(value) {
  return (value || "")
    .trim()
    .toLowerCase()
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ");
}

function isShortDivision(value) {
  return /^[a-d]$/.test(normalizeClassDivision(value));
}

function divisionAlias(value) {
  const normalized = normalizeClassDivision(value);
  const match = normalized.match(/^([a-d])(?:\.|\s|$)/);
  return match ? match[1] : normalized;
}

function classKeysMatch(leftKey, rightKey) {
  if (leftKey === rightKey) {
    return true;
  }

  const [leftStandard = "", ...leftDivisionParts] = String(leftKey || "").split("__");
  const [rightStandard = "", ...rightDivisionParts] = String(rightKey || "").split("__");
  if (!leftStandard || !rightStandard || leftStandard !== rightStandard) {
    return false;
  }

  const leftDivision = leftDivisionParts.join("__");
  const rightDivision = rightDivisionParts.join("__");
  if (!leftDivision || !rightDivision) {
    return false;
  }

  const leftNormalized = normalizeClassDivision(leftDivision);
  const rightNormalized = normalizeClassDivision(rightDivision);
  if (leftNormalized === rightNormalized) {
    return true;
  }

  const leftAlias = divisionAlias(leftDivision);
  const rightAlias = divisionAlias(rightDivision);
  return leftAlias === rightAlias && (isShortDivision(leftDivision) || isShortDivision(rightDivision));
}

export function classLabelFromKey(key) {
  if (!key) return "Unassigned";
  const [standard, division] = key.split("__");
  return standard && division ? `${standard} ${division}` : key;
}

export function getClassLabel(standard, division) {
  return `${standard} ${division}`;
}

export function getSchoolState() {
  const existing = readJSON(STORAGE_KEYS.school, null);
  if (existing) {
    const classes = uniqBy([...(existing.classes || []), ...DEFAULT_CLASSES], (item) => item.key);
    const migratedStudents = (existing.students || [])
      .filter((student) => !/^[^@]+@example\.com$/i.test(student.email || ""))
      .map((student) => {
        if (
          student.id === SEEDED_STUDENT.id ||
          normalizeText(student.email) === "dummy.student@eureka.school" ||
          normalizeText(student.name) === "dummy student" ||
          normalizeText(student.studentName) === "dummy student"
        ) {
          return {
            ...student,
            id: SEEDED_STUDENT.id,
            name: SEEDED_STUDENT.name,
            studentName: SEEDED_STUDENT.studentName,
            email: SEEDED_STUDENT.email,
          };
        }
        return student;
      });
    const students = uniqBy([...migratedStudents, SEEDED_STUDENT, ...DEFAULT_STUDENTS], (item) => item.id || item.email);
    const notifications = existing.notifications || [];
    const feesByStandard = Object.fromEntries(
      Object.entries(existing.feesByStandard || {}).map(([standard, plan]) => [
        standard,
        normalizeFeePlan(plan, existing.fees?.amount || 0, existing.fees?.dueDate || ""),
      ]),
    );
    const merged = {
      version: existing.version || 1,
      classes,
      students,
      attendance: {
        ...(existing.attendance || {}),
      },
      results: {
        ...sanitizeResults(existing.results || {}),
      },
      timetables: {
        ...Object.fromEntries(
          Object.entries(existing.timetables || {}).map(([targetClassKey, payload]) => [
            targetClassKey,
            stripTimetablePayload(payload),
          ]),
        ),
      },
      examSchedules: {
        ...Object.fromEntries(
          Object.entries(existing.examSchedules || {}).map(([targetClassKey, payload]) => [
            targetClassKey,
            stripSingleFilePayload(payload),
          ]),
        ),
      },
      syllabuses: {
        ...Object.fromEntries(
          Object.entries(existing.syllabuses || {}).map(([targetClassKey, payload]) => [
            targetClassKey,
            stripSingleFilePayload(payload),
          ]),
        ),
      },
      consentForms: {
        ...Object.fromEntries(
          Object.entries(existing.consentForms || {}).map(([targetClassKey, formData]) => [
            targetClassKey,
            formData && typeof formData === "object"
              ? {
                  ...formData,
                  teacherForm: stripSingleFilePayload(formData.teacherForm),
                  submissions: Object.fromEntries(
                    Object.entries(formData.submissions || {}).map(([studentId, payload]) => [
                      studentId,
                      stripSingleFilePayload(payload),
                    ]),
                  ),
                }
              : formData,
          ]),
        ),
      },
      homework: {
        ...(existing.homework || {}),
      },
      consentForms: {
        ...(existing.consentForms || {}),
      },
      remarks: {
        ...(existing.remarks || {}),
      },
      notifications,
      circulars: existing.circulars || [],
      editRequests: existing.editRequests || [],
      accountDeletionRequests: existing.accountDeletionRequests || [],
      leaveRequests: existing.leaveRequests || [],
      feesByStandard,
      feePayments: existing.feePayments || {},
      homepage: {
        ...DEFAULT_HOME_PAGE,
        ...(existing.homepage || {}),
        aboutUs:
          existing.homepage?.aboutUs &&
          !/welcome to eureka international school/i.test(existing.homepage.aboutUs)
            ? existing.homepage.aboutUs
            : DEFAULT_HOME_PAGE.aboutUs,
      },
      fees: {
        dueDate:
          existing.fees?.dueDate ||
          formatDateKey(addDays(new Date(), 3)),
        amount: existing.fees?.amount || 25000,
      },
    };
    writeJSON(STORAGE_KEYS.school, merged);
    ensureFeeReminder(merged);
    return merged;
  }

  const attendance = {};

  const school = {
    version: 1,
    classes: DEFAULT_CLASSES,
    students: [SEEDED_STUDENT, ...DEFAULT_STUDENTS],
    attendance,
    results: {},
    timetables: {},
    homework: {},
    consentForms: {},
    remarks: {},
    notifications: [],
    circulars: [],
    editRequests: [],
    accountDeletionRequests: [],
    leaveRequests: [],
    feesByStandard: {},
    feePayments: {},
    homepage: DEFAULT_HOME_PAGE,
    fees: {
      dueDate: formatDateKey(addDays(new Date(), 3)),
      amount: 25000,
    },
  };

  writeJSON(STORAGE_KEYS.school, school);
  ensureFeeReminder(school);
  return school;
}

export function saveSchoolState(nextState) {
  writeJSON(STORAGE_KEYS.school, {
    ...nextState,
    results: sanitizeResults(nextState.results || {}),
    timetables: Object.fromEntries(
      Object.entries(nextState.timetables || {}).map(([targetClassKey, payload]) => [
        targetClassKey,
        stripTimetablePayload(payload),
      ]),
    ),
    examSchedules: Object.fromEntries(
      Object.entries(nextState.examSchedules || {}).map(([targetClassKey, payload]) => [
        targetClassKey,
        stripSingleFilePayload(payload),
      ]),
    ),
    syllabuses: Object.fromEntries(
      Object.entries(nextState.syllabuses || {}).map(([targetClassKey, payload]) => [
        targetClassKey,
        stripSingleFilePayload(payload),
      ]),
    ),
    consentForms: Object.fromEntries(
      Object.entries(nextState.consentForms || {}).map(([targetClassKey, formData]) => [
        targetClassKey,
        formData && typeof formData === "object"
          ? {
              ...formData,
              teacherForm: stripSingleFilePayload(formData.teacherForm),
              submissions: Object.fromEntries(
                Object.entries(formData.submissions || {}).map(([studentId, payload]) => [
                  studentId,
                  stripSingleFilePayload(payload),
                ]),
              ),
            }
          : formData,
      ]),
    ),
  });
}

const STUDENT_DETAIL_FIELDS = {
  studentName: "Student Name",
  name: "Student Name",
  motherName: "Mother's Name",
  fatherName: "Father's Name",
  phone: "Phone Number",
  rollNo: "Roll Number",
  standard: "Standard",
  division: "Division",
  transportMode: "Mode of Transport",
  address: "Address",
  email: "Email",
  dob: "Date of Birth",
  bloodGroup: "Blood Group",
  emergencyContact: "Emergency Contact",
};

function formatNotificationValue(value) {
  if (value === undefined || value === null || value === "") {
    return "N/A";
  }
  return String(value);
}

function buildStudentChangeSummary(before, after) {
  return Object.keys(STUDENT_DETAIL_FIELDS)
    .map((field) => {
      const previous = before?.[field];
      const next = after?.[field];
      if (String(previous ?? "") === String(next ?? "")) {
        return null;
      }
      return {
        field,
        label: STUDENT_DETAIL_FIELDS[field] || field,
        oldValue: formatNotificationValue(previous),
        newValue: formatNotificationValue(next),
      };
    })
    .filter(Boolean);
}

export function getStudentRecordByIdentity({ studentName, standard, division }) {
  const school = getSchoolState();
  const targetName = normalizeText(studentName);
  return (
    school.students.find(
      (student) =>
        isPendingStudent(student) &&
        normalizeStudentName(student) === targetName &&
        student.standard === standard &&
        student.division === division,
    ) || null
  );
}

export function saveStudentRecord(record) {
  const school = getSchoolState();
  const targetName = normalizeText(record.name || record.studentName);
  const nextStudent = {
    id: record.id || crypto.randomUUID(),
    name: record.name?.trim() || record.studentName?.trim() || "",
    studentName: record.studentName?.trim() || record.name?.trim() || "",
    motherName: record.motherName?.trim() || "",
    fatherName: record.fatherName?.trim() || "",
    phone: record.phone?.trim() || "",
    rollNo: record.rollNo ? Number(record.rollNo) : "",
    standard: record.standard || "",
    division: record.division || "",
    transportMode: record.transportMode?.trim() || "",
    address: record.address?.trim() || "",
    email: record.email?.trim() || "",
    accountStatus: record.email ? "active" : "pending",
  };

  const nextStudents = (school.students || []).filter((student) => {
    if (student.id === nextStudent.id) {
      return false;
    }
    if (isPendingStudent(student) && normalizeStudentName(student) === targetName && student.standard === nextStudent.standard && student.division === nextStudent.division) {
      return false;
    }
    return true;
  });

  nextStudents.push(nextStudent);
  school.students = nextStudents;
  saveSchoolState(school);
  return nextStudent;
}

export function deleteStudentRecordById(studentId) {
  const school = getSchoolState();
  const student = (school.students || []).find((item) => item.id === studentId);
  if (!student) {
    return null;
  }

  school.students = (school.students || []).filter((item) => item.id !== studentId);
  if (student.email) {
    const accounts = getAccounts().filter(
      (account) =>
        !(
          account.role === "student" &&
          (account.studentId === studentId || account.email === student.email)
        ),
    );
    saveAccounts(accounts);
  }

  saveSchoolState(school);
  return student;
}

function appendNotifications(school, notifications) {
  const existing = school.notifications || [];
  const next = uniqBy([...existing, ...notifications].filter(Boolean), (item) => item.id);
  school.notifications = next;
  return school;
}

export function pushNotification(notification) {
  const school = getSchoolState();
  const next = appendNotifications({ ...school }, [notification]);
  saveSchoolState(next);
  return next;
}

function makeNotification({
  title,
  message,
  type,
  audience = {},
  link = "",
  metadata = {},
}) {
  return {
    id: crypto.randomUUID(),
    title,
    message,
    type,
    audience,
    link,
    metadata,
    createdAt: new Date().toISOString(),
    readBy: [],
  };
}

function notifyStudentsForClass(school, targetClassKey, notificationFactory) {
  const students = (school.students || []).filter(
    (student) => classKey(student.standard, student.division) === targetClassKey,
  );
  const notifications = students.map((student) => notificationFactory(student));
  appendNotifications(school, notifications);
}

function notifyStudentById(school, studentId, notificationFactory) {
  const student = (school.students || []).find((item) => item.id === studentId);
  if (!student) return school;
  appendNotifications(school, [notificationFactory(student)]);
}

export function getNotificationsForUser(user) {
  const school = getSchoolState();
  const key = userKey(user);
  const studentRecord = user?.role === "student" ? getStudentRecordForSession(user) : null;
  return (school.notifications || []).filter((notification) => {
    const audience = notification.audience || {};
    if (audience.role && audience.role !== user?.role) {
      return false;
    }
    if (audience.email && audience.email !== user?.email) {
      return false;
    }
    if (audience.userKey && audience.userKey !== key) {
      return false;
    }
    if (audience.studentId && studentRecord?.id !== audience.studentId) {
      return false;
    }
    if (audience.classKey && user?.role === "student") {
      return classKey(user.standard, user.division) === audience.classKey;
    }
    if (audience.classKey && user?.role === "teacher") {
      return user.assignedClassKey === audience.classKey;
    }
    if (audience.classKey && user?.role === "admin") {
      return true;
    }
    return true;
  });
}

export function markNotificationRead(notificationId, user) {
  const school = getSchoolState();
  const key = userKey(user);
  school.notifications = (school.notifications || []).map((notification) => {
    if (notification.id !== notificationId) {
      return notification;
    }
    const readBy = notification.readBy || [];
    if (readBy.includes(key)) {
      return notification;
    }
    return { ...notification, readBy: [...readBy, key] };
  });
  saveSchoolState(school);
}

function userHasRead(notification, user) {
  const key = userKey(user);
  return (notification.readBy || []).includes(key);
}

export function getUnreadNotificationCount(user) {
  return getNotificationsForUser(user).filter((notification) => !userHasRead(notification, user)).length;
}

export function ensureFeeReminder(schoolInput) {
  const school = schoolInput || getSchoolState();
  const dueDate = school.fees?.dueDate;
  if (!dueDate) return school;
  const today = formatDateKey(new Date());
  const due = new Date(`${dueDate}T00:00:00`);
  const current = new Date(`${today}T00:00:00`);
  const diffDays = Math.round((due - current) / (1000 * 60 * 60 * 24));
  if (diffDays !== 3) return school;

  const alreadySent = (school.notifications || []).some(
    (notification) =>
      notification.type === NOTIFICATION_TYPES.fees &&
      notification.metadata?.dueDate === dueDate,
  );
  if (alreadySent) return school;

  const notifications = (school.students || [])
    .filter((student) => !isTestPaymentStudent(student))
    .map((student) =>
      makeNotification({
        title: "Fee due soon",
        message: `Your fees are due on ${dueDate}. Please complete payment within 3 days.`,
        type: NOTIFICATION_TYPES.fees,
        audience: {
          role: "student",
          studentId: student.id,
          classKey: classKey(student.standard, student.division),
        },
        metadata: { dueDate, amount: school.fees?.amount || 0 },
      }),
    );

  school.notifications = uniqBy([...(school.notifications || []), ...notifications], (item) => item.id);
  saveSchoolState(school);
  return school;
}

export function getAccounts() {
  const existing = readJSON(STORAGE_KEYS.accounts, []);
  const migratedExisting = existing.map((account) => {
    if (
      account.role === "student" &&
      (account.id === SEEDED_STUDENT_ACCOUNT.id ||
        normalizeText(account.email) === "dummy.student@eureka.school" ||
        normalizeText(account.name) === "dummy student" ||
        normalizeText(account.studentName) === "dummy student")
    ) {
      return {
        ...account,
        id: SEEDED_STUDENT_ACCOUNT.id,
        studentId: SEEDED_STUDENT_ACCOUNT.studentId,
        name: SEEDED_STUDENT_ACCOUNT.name,
        email: SEEDED_STUDENT_ACCOUNT.email,
        studentName: SEEDED_STUDENT_ACCOUNT.studentName,
      };
    }
    return account;
  });
  const accounts = uniqBy(
    [
      SEEDED_STUDENT_ACCOUNT,
      SEEDED_TEACHER_ACCOUNT,
      SEEDED_ADMIN_ACCOUNT,
      SEEDED_MANAGEMENT_ACCOUNT,
      ...migratedExisting,
    ],
    (item) => `${item.role}:${item.email}`,
  );
  if (accounts.length !== existing.length) {
    saveAccounts(accounts);
  }
  return accounts;
}

export function saveAccounts(accounts) {
  writeJSON(STORAGE_KEYS.accounts, accounts);
}

export function upsertAccount(account) {
  const accounts = getAccounts();
  const next = accounts.filter((item) => !(item.email === account.email && item.role === account.role));
  next.push(account);
  saveAccounts(next);
  return account;
}

export function findAccount({ role, email }) {
  return getAccounts().find((account) => account.role === role && account.email === email) || null;
}

export function authenticateAccount({ role, email, password }) {
  const account = findAccount({ role, email });
  if (!account || account.password !== password) {
    return null;
  }
  return account;
}

export function isTestPaymentStudent(userOrRecord) {
  if (!userOrRecord) {
    return false;
  }

  const values = [
    userOrRecord.id,
    userOrRecord.studentId,
    userOrRecord.name,
    userOrRecord.studentName,
    userOrRecord.email,
  ].map((value) => normalizeText(value));

  return values.some(
    (value) =>
      value === "test8" ||
      value === TEST_PAYMENT_STUDENT.email ||
      value === SEEDED_STUDENT.id,
  );
}

export function saveSessionUser(user) {
  writeJSON(STORAGE_KEYS.session, sanitizeSessionUser(user));
}

export function getSessionUser() {
  return readJSON(STORAGE_KEYS.session, null);
}

export function clearSessionUser() {
  localStorage.removeItem(STORAGE_KEYS.session);
}

export function createStudentAccount({
  name,
  email,
  password,
  studentName,
  motherName,
  fatherName,
  standard,
  division,
  phone,
  rollNo,
  transportMode,
  address,
}) {
  const school = getSchoolState();
  const matchedStudent = getStudentRecordByIdentity({
    studentName: studentName || name,
    standard,
    division,
  });

  if (!matchedStudent) {
    return null;
  }

  const account = {
    id: matchedStudent.id,
    studentId: matchedStudent.id,
    role: "student",
    name: matchedStudent.name || name,
    email,
    password,
    studentName: matchedStudent.studentName || studentName || name,
    motherName: matchedStudent.motherName || motherName || "",
    fatherName: matchedStudent.fatherName || fatherName || "",
    phone: matchedStudent.phone || phone || "",
    rollNo: matchedStudent.rollNo || rollNo || "",
    standard: matchedStudent.standard || standard,
    division: matchedStudent.division || division,
    transportMode: matchedStudent.transportMode || transportMode || "",
    address: matchedStudent.address || address || "",
    classKey: classKey(matchedStudent.standard || standard, matchedStudent.division || division),
  };
  upsertAccount(account);

  school.students = (school.students || []).map((student) =>
    student.id === matchedStudent.id
      ? {
          ...student,
          id: matchedStudent.id,
          name: account.name,
          studentName: account.studentName,
          motherName: account.motherName,
          fatherName: account.fatherName,
          phone: account.phone,
          rollNo: account.rollNo,
          standard: account.standard,
          division: account.division,
          transportMode: account.transportMode,
          address: account.address,
          email,
          accountStatus: "active",
        }
      : student,
  );
  saveSchoolState(school);

  return account;
}

export function createTeacherAccount({ id, name, email, password, assignedClassKey = "" }) {
  const account = {
    id: id || crypto.randomUUID(),
    role: "teacher",
    name,
    email,
    password,
    assignedClassKey,
  };
  return upsertAccount(account);
}

export function createAdminAccount({ name, email, password }) {
  const account = {
    id: crypto.randomUUID(),
    role: "admin",
    name,
    email,
    password,
  };
  return upsertAccount(account);
}

export function createManagementAccount({ name, email, password }) {
  const account = {
    id: crypto.randomUUID(),
    role: "management",
    name,
    email,
    password,
  };
  return upsertAccount(account);
}

export function getTeachers() {
  return getAccounts().filter((account) => account.role === "teacher");
}

export function getFeeConfiguration() {
  const school = getSchoolState();
  return {
    defaultAmount: school.fees?.amount || 0,
    defaultDueDate: school.fees?.dueDate || "",
    byStandard: school.feesByStandard || {},
  };
}

export function getFeeConfigurationForStandard(standard) {
  const school = getSchoolState();
  const feesByStandard = school.feesByStandard || {};
  return feesByStandard[standard]
    ? normalizeFeePlan(feesByStandard[standard], school.fees?.amount || 0, school.fees?.dueDate || "")
    : getDefaultFeePlanForStandard(standard);
}

export function saveFeeConfigurationForStandard(standard, updates) {
  const school = getSchoolState();
  school.feesByStandard = {
    ...(school.feesByStandard || {}),
    [standard]: {
      ...getFeeConfigurationForStandard(standard),
      ...updates,
    },
  };
  school.feesByStandard[standard] = normalizeFeePlan(
    school.feesByStandard[standard],
    school.fees?.amount || 0,
    school.fees?.dueDate || "",
  );
  saveSchoolState(school);
  return school.feesByStandard[standard];
}

export function getFeePaymentsForStudent(targetClassKey, studentId) {
  const school = getSchoolState();
  return school.feePayments?.[targetClassKey]?.[studentId] || [];
}

export function saveFeePaymentForStudent(targetClassKey, studentId, payment) {
  const school = getSchoolState();
  const existing = school.feePayments?.[targetClassKey] || {};
  const studentPayments = existing[studentId] || [];
  const nextPayment = {
    id: crypto.randomUUID(),
    amount: Number(payment.amount) || 0,
    paidAt: payment.paidAt || new Date().toISOString(),
    note: payment.note || "",
  };
  school.feePayments = {
    ...(school.feePayments || {}),
    [targetClassKey]: {
      ...existing,
      [studentId]: [...studentPayments, nextPayment],
    },
  };
  saveSchoolState(school);
  return nextPayment;
}

export function getFeeSummaryForStudent(targetClassKey, studentId, standard) {
  const plan = getFeeConfigurationForStandard(standard);
  const payments = getFeePaymentsForStudent(targetClassKey, studentId);
  const paidAmount = payments.reduce((sum, payment) => sum + Number(payment.amount || 0), 0);
  const totalAmount = Number(plan.totalAmount || plan.amount || 0);
  return {
    plan,
    payments,
    paidAmount,
    dueAmount: Math.max(totalAmount - paidAmount, 0),
  };
}

export function getFeeInstallmentProgress(targetClassKey, studentId, standard) {
  const summary = getFeeSummaryForStudent(targetClassKey, studentId, standard);
  const installments = (Array.isArray(summary.plan?.installments) ? summary.plan.installments : []).filter(
    (installment) => Number(installment?.amount || 0) > 0,
  );
  const paidAmount = Number(summary.paidAmount || 0);
  let runningTotal = 0;
  let nextInstallment = null;
  const installmentStatuses = installments.map((installment, index) => {
    const amount = Number(installment?.amount || 0);
    const start = runningTotal;
    const end = runningTotal + amount;
    runningTotal = end;

    let status = "upcoming";
    let remaining = amount;

    if (amount <= 0) {
      status = "paid";
      remaining = 0;
    } else if (paidAmount >= end) {
      status = "paid";
      remaining = 0;
    } else if (paidAmount > start) {
      status = "partial";
      remaining = Math.max(end - paidAmount, 0);
    } else if (!nextInstallment) {
      nextInstallment = {
        ...installment,
        index,
        amount,
        remaining: amount,
      };
      status = "due";
    }

    return {
      ...installment,
      index,
      amount,
      remaining,
      status,
    };
  });

  return {
    ...summary,
    installmentStatuses,
    nextInstallment,
    nextAmount: nextInstallment?.remaining || 0,
    nextDueDate: nextInstallment?.dueDate || summary.plan?.dueDate || "",
    isFullyPaid: !nextInstallment && summary.dueAmount === 0,
  };
}

export function getStudentsForClass(targetClassKey) {
  const school = getSchoolState();
  return school.students
    .filter((student) => classKeysMatch(classKey(student.standard, student.division), targetClassKey))
    .sort((a, b) => (a.rollNo || 0) - (b.rollNo || 0));
}

export function getAttendanceRecords(targetClassKey) {
  const school = getSchoolState();
  return school.attendance?.[targetClassKey] || {};
}

export function getAttendanceForStudent(targetClassKey, studentId) {
  const records = getAttendanceRecords(targetClassKey);
  return Object.entries(records)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, dayRecord]) => ({
      date,
      status: dayRecord?.[studentId] || "present",
    }));
}

export function saveAttendanceRecord(targetClassKey, date, records) {
  const school = getSchoolState();
  school.attendance = {
    ...(school.attendance || {}),
    [targetClassKey]: {
      ...(school.attendance?.[targetClassKey] || {}),
      [date]: records,
    },
  };
  notifyStudentsForClass(school, targetClassKey, (student) => {
    const status = records[student.id] || "present";
    if (status !== "absent") {
      return null;
    }
    return makeNotification({
      title: "Attendance update",
      message: `You were marked absent on ${date}.`,
      type: NOTIFICATION_TYPES.attendance,
      audience: {
        role: "student",
        studentId: student.id,
        classKey: targetClassKey,
      },
      metadata: { date, status },
    });
  });
  school.notifications = (school.notifications || []).filter(Boolean);
  saveSchoolState(school);
  return school;
}

export function getResultsForClass(targetClassKey) {
  const school = getSchoolState();
  return school.results?.[targetClassKey] || {};
}

export function saveResultPdf(targetClassKey, studentId, examKey, payload) {
  const school = getSchoolState();
  school.results = {
    ...(school.results || {}),
    [targetClassKey]: {
      ...(school.results?.[targetClassKey] || {}),
      [studentId]: {
        ...(school.results?.[targetClassKey]?.[studentId] || {}),
        [examKey]: stripResultPayload(payload),
      },
    },
  };
  notifyStudentById(school, studentId, (student) =>
    makeNotification({
      title: "Result uploaded",
      message: `${student.name}'s ${EXAMS.find((exam) => exam.key === examKey)?.label || examKey} result is ready.`,
      type: NOTIFICATION_TYPES.upload,
      audience: {
        role: "student",
        studentId: student.id,
        classKey: targetClassKey,
      },
      metadata: { examKey, studentId, targetClassKey },
    }),
  );
  saveSchoolState(school);
  return school;
}

export function getTimetableForClass(targetClassKey) {
  const school = getSchoolState();
  return school.timetables?.[targetClassKey] || null;
}

export function saveTimetableForClass(targetClassKey, payload) {
  const school = getSchoolState();
  school.timetables = {
    ...(school.timetables || {}),
    [targetClassKey]: payload,
  };
  notifyStudentsForClass(school, targetClassKey, (student) =>
    makeNotification({
      title: "Timetable uploaded",
      message: `Your class timetable is now available for ${student.standard} ${student.division}.`,
      type: NOTIFICATION_TYPES.upload,
      audience: {
        role: "student",
        studentId: student.id,
        classKey: targetClassKey,
      },
      metadata: { targetClassKey },
    }),
  );
  saveSchoolState(school);
  return school;
}

export function saveSingleFileForClass(collectionName, targetClassKey, payload) {
  const school = getSchoolState();
  school[collectionName] = {
    ...(school[collectionName] || {}),
    [targetClassKey]: stripSingleFilePayload(payload),
  };
  const titleMap = {
    examSchedules: "Exam schedule uploaded",
    syllabuses: "Syllabus uploaded",
  };
  const messageMap = {
    examSchedules: "A new exam schedule has been uploaded for your class.",
    syllabuses: "A new syllabus has been uploaded for your class.",
  };
  if (collectionName === "examSchedules" || collectionName === "syllabuses") {
    notifyStudentsForClass(school, targetClassKey, (student) =>
      makeNotification({
        title: titleMap[collectionName],
        message: messageMap[collectionName],
        type: NOTIFICATION_TYPES.upload,
        audience: {
          role: "student",
          studentId: student.id,
          classKey: targetClassKey,
        },
        metadata: { collectionName, targetClassKey },
      }),
    );
  }
  saveSchoolState(school);
  return school;
}

export function getSingleFileForClass(collectionName, targetClassKey) {
  const school = getSchoolState();
  return school[collectionName]?.[targetClassKey] || null;
}

export function saveHomeworkForClass(targetClassKey, homeworkEntry) {
  const school = getSchoolState();
  const next = school.homework || {};
  const items = next[targetClassKey] || [];
  next[targetClassKey] = [
    ...items,
    {
      id: crypto.randomUUID(),
      ...homeworkEntry,
      createdAt: new Date().toISOString(),
    },
  ];
  school.homework = next;
  notifyStudentsForClass(school, targetClassKey, (student) =>
    makeNotification({
      title: "Homework assigned",
      message: `${homeworkEntry.subject}: ${homeworkEntry.homework}`,
      type: NOTIFICATION_TYPES.upload,
      audience: {
        role: "student",
        studentId: student.id,
        classKey: targetClassKey,
      },
      metadata: { targetClassKey, homeworkId: next[targetClassKey][0]?.id },
    }),
  );
  saveSchoolState(school);
  return school;
}

export function getHomeworkForClass(targetClassKey) {
  const school = getSchoolState();
  return school.homework?.[targetClassKey] || [];
}

export function saveConsentFormForClass(targetClassKey, payload) {
  const school = getSchoolState();
  const existing = school.consentForms?.[targetClassKey] || {
    teacherForm: null,
    submissions: {},
  };
  school.consentForms = {
    ...(school.consentForms || {}),
    [targetClassKey]: {
      ...existing,
      teacherForm: stripSingleFilePayload(payload),
    },
  };
  notifyStudentsForClass(school, targetClassKey, (student) =>
    makeNotification({
      title: "Consent form uploaded",
      message: "Your class consent form is available to view.",
      type: NOTIFICATION_TYPES.upload,
      audience: {
        role: "student",
        studentId: student.id,
        classKey: targetClassKey,
      },
      metadata: { targetClassKey },
    }),
  );
  saveSchoolState(school);
  return school;
}

export function getConsentFormForClass(targetClassKey) {
  const school = getSchoolState();
  return school.consentForms?.[targetClassKey] || {
    teacherForm: null,
    submissions: {},
  };
}

export function saveConsentSubmissionForClass(targetClassKey, studentId, payload) {
  const school = getSchoolState();
  const existing = school.consentForms?.[targetClassKey] || {
    teacherForm: null,
    submissions: {},
  };
  school.consentForms = {
    ...(school.consentForms || {}),
    [targetClassKey]: {
      ...existing,
      submissions: {
        ...(existing.submissions || {}),
        [studentId]: stripSingleFilePayload(payload),
      },
    },
  };
  saveSchoolState(school);
  return school;
}

export function saveRemarkForStudent(targetClassKey, studentId, payload) {
  const school = getSchoolState();
  const next = school.remarks || {};
  const classRemarks = next[targetClassKey] || {};
  const studentRemarks = classRemarks[studentId] || [];
  const student = (school.students || []).find((item) => item.id === studentId) || null;
  const studentName = student?.studentName || student?.name || payload?.studentName || "Student";
  classRemarks[studentId] = [
    ...studentRemarks,
    {
      id: crypto.randomUUID(),
      ...payload,
      createdAt: new Date().toISOString(),
    },
  ];
  next[targetClassKey] = classRemarks;
  school.remarks = next;
  appendNotifications(school, [
    makeNotification({
      title: "New remark added",
      message: `${studentName} received a new remark.`,
      type: NOTIFICATION_TYPES.remark,
      audience: { role: "management" },
      metadata: {
        studentId,
        studentName,
        standard: student?.standard || payload?.standard || "",
        division: student?.division || payload?.division || "",
        remark: payload?.text || "",
        teacherName: payload?.teacherName || "",
      },
    }),
  ]);
  saveSchoolState(school);
  return school;
}

export function getRemarksForStudent(targetClassKey, studentId) {
  const school = getSchoolState();
  return school.remarks?.[targetClassKey]?.[studentId] || [];
}

export function getRemarksForClass(targetClassKey) {
  const school = getSchoolState();
  return school.remarks?.[targetClassKey] || {};
}

export function getStudentRecordForSession(user) {
  if (!user) return null;
  const school = getSchoolState();
  return (
    school.students.find((student) => student.id === user.studentId || student.id === user.id) ||
    school.students.find((student) => student.email === user.email) ||
    school.students.find((student) => student.id === user.id) ||
    school.students.find((student) => student.name === user.name || student.studentName === user.studentName) ||
    null
  );
}

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export function ensureClassForTeacher(account) {
  if (!account || account.role !== "teacher") {
    return account;
  }

  const school = getSchoolState();
  const teacherClass = school.classes.find((item) => classKeysMatch(item.key, account.assignedClassKey));
  if (teacherClass || !school.classes.length) {
    return account;
  }

  const fallbackClass = school.classes[0];
  const updated = {
    ...account,
    assignedClassKey: fallbackClass.key,
  };
  upsertAccount(updated);
  return updated;
}

export function updateTeacherClass(accountEmail, classKeyValue) {
  const accounts = getAccounts();
  const updated = accounts.map((account) => {
    if (account.role === "teacher" && account.email === accountEmail) {
      return { ...account, assignedClassKey: classKeyValue };
    }
    return account;
  });
  saveAccounts(updated);
  const session = getSessionUser();
  if (session?.email === accountEmail && session.role === "teacher") {
    saveSessionUser({ ...session, assignedClassKey: classKeyValue });
  }
}

export function updateAccountProfile(originalEmail, role, updates) {
  const accounts = getAccounts();
  const next = accounts.map((account) => {
    if (account.role === role && account.email === originalEmail) {
      return { ...account, ...updates };
    }
    return account;
  });
  saveAccounts(next);

  const session = getSessionUser();
  if (session?.role === role && session.email === originalEmail) {
    saveSessionUser({ ...session, ...updates });
  }
}

export function updateStudentDataById(studentId, updates) {
  const school = getSchoolState();
  const existingStudent = (school.students || []).find((student) => student.id === studentId);
  if (!existingStudent) {
    return null;
  }

  const nextStudents = (school.students || []).map((student) => {
    if (student.id !== studentId) {
      return student;
    }
    return {
      ...student,
      name: updates.name || updates.studentName || student.name,
      studentName: updates.studentName || updates.name || student.studentName || student.name,
      ...updates,
      email: student.email,
      accountStatus: student.accountStatus || (student.email ? "active" : "pending"),
      classKey: classKey(
        updates.standard || student.standard,
        updates.division || student.division,
      ),
    };
  });
  const updatedStudent = nextStudents.find((student) => student.id === studentId) || existingStudent;
  const changes = buildStudentChangeSummary(existingStudent, updatedStudent);

  school.students = nextStudents;
  school.editRequests = (school.editRequests || []).map((request) => {
    if (request.studentId !== studentId || request.status !== "pending") {
      return request;
    }
    return {
      ...request,
      status: "completed",
      resolvedAt: new Date().toISOString(),
    };
  });

  if (changes.length) {
    appendNotifications(
      school,
      [
        makeNotification({
          title: "Student details updated",
          message: `${updatedStudent.studentName || updatedStudent.name || "Student"} details were updated.`,
          type: NOTIFICATION_TYPES.admin_update,
          audience: { role: "management" },
          metadata: {
            studentId: updatedStudent.id,
            studentName: updatedStudent.studentName || updatedStudent.name || "",
            standard: updatedStudent.standard || "",
            division: updatedStudent.division || "",
            changes,
          },
        }),
        makeNotification({
          title: "Your requested changes were updated",
          message: "Your requested changes were updated.",
          type: NOTIFICATION_TYPES.admin_update,
          audience: {
            role: "student",
            studentId: updatedStudent.id,
            classKey: classKey(updatedStudent.standard, updatedStudent.division),
          },
          metadata: {
            studentId: updatedStudent.id,
            studentName: updatedStudent.studentName || updatedStudent.name || "",
            standard: updatedStudent.standard || "",
            division: updatedStudent.division || "",
            changes,
          },
        }),
      ],
    );
  }

  saveSchoolState(school);

  const accountEmail = existingStudent?.email;
  if (accountEmail) {
    updateAccountProfile(accountEmail, "student", {
      ...updatedStudent,
      role: "student",
      name: updatedStudent.studentName || updatedStudent.name,
    });
  }

  return updatedStudent;
}

export function saveCircularForAllClasses(circularEntry) {
  const school = getSchoolState();
  const item = {
    id: crypto.randomUUID(),
    ...circularEntry,
    audience: "all",
    createdAt: new Date().toISOString(),
  };
  school.circulars = [item, ...(school.circulars || [])];
  appendNotifications(
    school,
    (school.students || []).map((student) =>
      makeNotification({
        title: "New circular published",
        message: circularEntry.title || "A new circular has been uploaded for your class.",
        type: NOTIFICATION_TYPES.circular,
        audience: {
          role: "student",
          studentId: student.id,
          classKey: classKey(student.standard, student.division),
        },
        metadata: { circularId: item.id },
      }),
    ),
  );
  saveSchoolState(school);
  return item;
}

export function getCirculars() {
  const school = getSchoolState();
  return school.circulars || [];
}

export function saveHomepageContent(updates) {
  const school = getSchoolState();
  school.homepage = {
    ...(school.homepage || DEFAULT_HOME_PAGE),
    ...updates,
  };
  saveSchoolState(school);
  return school.homepage;
}

export function getHomepageContent() {
  const school = getSchoolState();
  return {
    ...DEFAULT_HOME_PAGE,
    ...(school.homepage || {}),
  };
}

export function saveStudentEditRequest(request) {
  const school = getSchoolState();
  const item = {
    id: crypto.randomUUID(),
    ...request,
    status: "pending",
    createdAt: new Date().toISOString(),
  };
  school.editRequests = [item, ...(school.editRequests || [])];
  appendNotifications(
    school,
    [
      makeNotification({
        title: "Student edit request",
        message: `${request.studentName} (${request.standard} ${request.division}) wants to change ${request.field} to ${request.newValue}`,
        type: NOTIFICATION_TYPES.edit_request,
        audience: { role: "admin" },
        metadata: { requestId: item.id, ...request },
      }),
    ],
  );
  saveSchoolState(school);
  return item;
}

export function getStudentEditRequests() {
  const school = getSchoolState();
  return school.editRequests || [];
}

export function saveStudentDeleteRequest(request) {
  const school = getSchoolState();
  const studentId = request.studentId || "";
  const studentEmail = request.studentEmail || "";
  const existingRequest = (school.accountDeletionRequests || []).find((item) => {
    if (studentId && item.studentId === studentId) return true;
    if (studentEmail && item.studentEmail === studentEmail) return true;
    return false;
  });

  if (existingRequest) {
    return existingRequest;
  }

  const item = {
    id: crypto.randomUUID(),
    ...request,
    status: "pending",
    createdAt: new Date().toISOString(),
  };

  school.accountDeletionRequests = [item, ...(school.accountDeletionRequests || [])];
  appendNotifications(school, [
    makeNotification({
      title: "Student account deletion request",
      message: `${request.studentName} (${request.standard} ${request.division}) requested account deletion.`,
      type: NOTIFICATION_TYPES.account_delete_request,
      audience: { role: "admin" },
      metadata: {
        requestId: item.id,
        ...request,
      },
    }),
  ]);
  saveSchoolState(school);
  return item;
}

export function getStudentDeleteRequests() {
  const school = getSchoolState();
  return school.accountDeletionRequests || [];
}

export function getStudentDeleteRequestForUser(user) {
  const school = getSchoolState();
  const studentRecord = user?.role === "student" ? getStudentRecordForSession(user) : null;
  return (school.accountDeletionRequests || []).find((request) => {
    if (studentRecord?.id && request.studentId === studentRecord.id) return true;
    if (user?.email && request.studentEmail === user.email) return true;
    return false;
  }) || null;
}

export function saveLeaveRequest(request) {
  const school = getSchoolState();
  const item = {
    id: crypto.randomUUID(),
    ...request,
    status: "pending",
    createdAt: new Date().toISOString(),
  };
  school.leaveRequests = [item, ...(school.leaveRequests || [])];
  appendNotifications(
    school,
    [
      makeNotification({
        title: "Teacher leave request",
        message: `${request.teacherName} requested leave from ${request.fromDate} to ${request.toDate}.`,
        type: NOTIFICATION_TYPES.leave_request,
        audience: { role: "management" },
        metadata: { requestId: item.id, ...request },
      }),
      makeNotification({
        title: "Leave request submitted",
        message: `Your leave request for ${request.fromDate} to ${request.toDate} has been sent to management.`,
        type: NOTIFICATION_TYPES.leave_request,
        audience: {
          role: "teacher",
          userKey: userKey({
            role: "teacher",
            email: request.teacherEmail,
            name: request.teacherName,
          }),
        },
        metadata: { requestId: item.id, ...request },
      }),
    ],
  );
  saveSchoolState(school);
  return item;
}

export function getLeaveRequests() {
  const school = getSchoolState();
  return school.leaveRequests || [];
}

export function getLeaveRequestById(requestId) {
  const school = getSchoolState();
  return (school.leaveRequests || []).find((request) => request.id === requestId) || null;
}

export function resolveLeaveRequest(requestId, decision) {
  const school = getSchoolState();
  const nextRequests = (school.leaveRequests || []).map((request) => {
    if (request.id !== requestId) {
      return request;
    }
    return {
      ...request,
      status: decision,
      resolvedAt: new Date().toISOString(),
    };
  });
  const updated = nextRequests.find((request) => request.id === requestId) || null;
  school.leaveRequests = nextRequests;

  if (updated) {
    appendNotifications(
      school,
      [
        makeNotification({
          title: `Leave request ${decision}`,
          message: `Your leave request from ${updated.fromDate} to ${updated.toDate} has been ${decision}.`,
          type: NOTIFICATION_TYPES.leave_status,
          audience: {
            role: "teacher",
            userKey: userKey({
              role: "teacher",
              email: updated.teacherEmail,
              name: updated.teacherName,
            }),
          },
          metadata: { requestId, decision, ...updated },
        }),
      ],
    );
  }

  saveSchoolState(school);
  return updated;
}

export function resolveStudentEditRequest(requestId, studentId, updates) {
  const school = getSchoolState();
  school.editRequests = (school.editRequests || []).map((request) => {
    if (request.id !== requestId) {
      return request;
    }
    return { ...request, status: "completed", resolvedAt: new Date().toISOString() };
  });
  const updatedStudent = updateStudentDataById(studentId, updates);
  const refreshedSchool = getSchoolState();
  refreshedSchool.editRequests = school.editRequests;
  if (updatedStudent) {
    refreshedSchool.students = (refreshedSchool.students || []).map((student) =>
      student.id === updatedStudent.id ? updatedStudent : student,
    );
  }
  saveSchoolState(refreshedSchool);
  return school;
}

export function getTeacherAssignedClass(account) {
  if (!account) return null;
  const school = getSchoolState();
  return school.classes.find((item) => classKeysMatch(item.key, account.assignedClassKey)) || null;
}

export function getStudentClassKey(student) {
  if (!student?.standard || !student?.division) {
    return "";
  }
  return classKey(student.standard, student.division);
}
